module.exports = __webpack_public_path__ + "img/apple1.f627e463.png";